export default __webpack_public_path__ + "static/media/work.e493cafa.png";